;(function () {
    const BANNER_ID = "shopify-pc__banner"
    const PREFS_ID = "shopify-pc__prefs"

    const CSM_HOST = "csm-cookie-consent"
    const CSM_WRAPPER_ID = "csm-wrapper"

    let locked = false
    let observedBanner = null
    const bannerObserver = new MutationObserver(update)

    let csmHost = null
    let csmWrapper = null
    let csmWrapperOpen = true
    const csmHostObserver = new MutationObserver(update)
    const csmShadowObserver = new MutationObserver(update)
    const csmResizeObserver = new ResizeObserver(([entry]) => {
        const el = entry.target
        csmWrapperOpen = el.offsetWidth > 0 && el.offsetHeight > 0
        update()
    })

    function isVisible(el) {
        return !!el && el.isConnected && getComputedStyle(el).display !== "none"
    }

    function otherLockActive() {
        return (
            document.body.classList.contains("!overflow-hidden") ||
            document.body.classList.contains("overflow-hidden") ||
            window.menuOpen ||
            !!document.querySelector("loading-animation")
        )
    }

    function setLocked(next) {
        if (next === locked) return
        locked = next

        if (!window.lenis) return
        if (locked) window.lenis.stop()
        else if (!otherLockActive()) window.lenis.start()
    }

    function csmBannerOpen() {
        const host = document.querySelector(CSM_HOST)

        if (host !== csmHost) {
            csmHostObserver.disconnect()
            csmShadowObserver.disconnect()
            csmResizeObserver.disconnect()
            csmHost = host
            csmWrapper = null
            csmWrapperOpen = true
            if (host) {
                host.setAttribute("data-lenis-prevent", "")
                csmHostObserver.observe(host, {
                    attributes: true,
                    attributeFilter: ["class"],
                })
            }
        }

        if (
            !host ||
            !host.classList.contains("csm-cmp-root") ||
            !host.classList.contains("needsclick")
        ) {
            return false
        }

        const wrapper = host.shadowRoot?.getElementById(CSM_WRAPPER_ID) ?? null
        if (wrapper !== csmWrapper) {
            csmResizeObserver.disconnect()
            csmShadowObserver.disconnect()
            csmWrapper = wrapper
            csmWrapperOpen = true
            if (wrapper) csmResizeObserver.observe(wrapper)
        }
        if (!wrapper && host.shadowRoot) {
            csmShadowObserver.observe(host.shadowRoot, {
                childList: true,
                subtree: true,
            })
        }

        return csmWrapperOpen
    }

    function update() {
        const banner = document.getElementById(BANNER_ID)

        for (const id of [BANNER_ID, PREFS_ID]) {
            document.getElementById(id)?.setAttribute("data-lenis-prevent", "")
        }

        if (banner !== observedBanner) {
            bannerObserver.disconnect()
            if (banner) {
                bannerObserver.observe(banner, {
                    attributes: true,
                    attributeFilter: ["style", "class", "hidden"],
                })
            }
            observedBanner = banner
        }

        const csmOpen = csmBannerOpen()
        setLocked(isVisible(banner) || csmOpen)
    }

    window.lenis?.on("scroll", (lenis) => {
        if (locked && !lenis.isStopped) lenis.stop()
    })

    new MutationObserver(update).observe(document.body, { childList: true })
    update()
})()
